import { render, staticRenderFns } from "./sidebar-nav.vue?vue&type=template&id=36c992b7"
import script from "./sidebar-nav.vue?vue&type=script&lang=js"
export * from "./sidebar-nav.vue?vue&type=script&lang=js"
import style0 from "./sidebar-nav.vue?vue&type=style&index=0&id=36c992b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports